const OldQuotePricing = () => {
  /**
   * Adjusts price with provided Margin
   * @param {float} price
   * @param {float} margin 
   * @returns {float}
   * @private
   */
  function calcPriceWithMargin(price, margin) {
    const total = parseFloat(price);
    return (total + (margin * total));
  }

  /**
   * Checks whether the quantity is valid for a given StoneSupplierStone
   * @param stoneSupplierStone {object}
   * @param quantity {int}
   * @returns {boolean}
   * @private
   */
  function validStoneSupplierStonePrice(stoneSupplierStone, quantity) {
    let ret = false;
    let material = quantity;
    if (stoneSupplierStone.PerQuantity > 1) {
      material = Math.ceil(material / stoneSupplierStone.PerQuantity);
    }
    switch (stoneSupplierStone.ComparisonType) {
      case "lte":
        if (material <= stoneSupplierStone.BaseQuantity) {
          ret = true;
        }
        break;
      case "between":
        if (material >= stoneSupplierStone.BaseQuantity && material <= stoneSupplierStone.MaxQuantity) {
          ret = true;
        }
        break;
      case "gte":
      case "gte+":
        if (material >= stoneSupplierStone.BaseQuantity) {
          ret = true;
        }
        break;
      default:
        ret = true;
    }
    return ret;
  }

  return {
    /**
     * Calculates the prices onle for a specific stone
     * @param stone {object}
     * @param quantity {int}
     * @returns {number}
     */
    calculateStonePrice: (stone, quantity) => {
      let minPrice = -1;
      _.each(stone.StoneSupplierStones, function (stoneSupplierStone) {
        let price = stoneSupplierStone.Price;
        if (stoneSupplierStone.PricePlus > 0) {
          price = stoneSupplierStone.PricePlus;
        }
        let material = quantity;
        if (stoneSupplierStone.PerQuantity > 1) {
          material = Math.ceil(material / stoneSupplierStone.PerQuantity);
        }
        let materialPrice = price * parseFloat(material);

        let baseQuantity;
        if (stoneSupplierStone.ComparisonType === "gte+") {
          baseQuantity = parseInt(stoneSupplierStone.BaseQuantity) - 1;
          if (material > baseQuantity) {
            let perUnit = parseFloat(stoneSupplierStone.MaxQuantity);
            const margin = stoneSupplierStone.StoneSupplier.Margin;
            perUnit = calcPriceWithMargin(perUnit, margin);
            materialPrice = baseQuantity * price;
            _.each(stone.StoneSupplierStones, function (stoneSupplierStoneInner) {
              if (stoneSupplierStoneInner.ComparisonType === "between" && material >= stoneSupplierStoneInner.BaseQuantity) {
                materialPrice = stoneSupplierStoneInner.Price;
                for (let n = stoneSupplierStoneInner.MaxQuantity + 1; n <= baseQuantity; n++) {
                  materialPrice += price;
                }
              }
            });
            for (let i = baseQuantity + 1; i <= material; i++) {
              materialPrice += perUnit;
            }
          }
        } else if (stoneSupplierStone.ComparisonType === "min") {
          if (parseFloat(material) < stoneSupplierStone.BaseQuantity) {
            materialPrice = price * parseFloat(stoneSupplierStone.BaseQuantity);
          }
        } else if (stoneSupplierStone.ComparisonType === "lte") {
          baseQuantity = parseInt(stoneSupplierStone.BaseQuantity);
          if (material <= baseQuantity) {
            let bFoundOther = false;
            _.each(stone.StoneSupplierStones, function (stoneSupplierStoneInner) {
              if (stoneSupplierStoneInner.ComparisonType === "lte" && material <= stoneSupplierStoneInner.BaseQuantity
                && stoneSupplierStoneInner.BaseQuantity < baseQuantity) {
                bFoundOther = true;
              }
            });
            if (bFoundOther) {
              return;
            }
          }
        } else if (stoneSupplierStone.ComparisonType === "between") {
          materialPrice = stoneSupplierStone.Price;
        }

        if (validStoneSupplierStonePrice(stoneSupplierStone, material)) {
          if (minPrice === -1 || minPrice > materialPrice) {
            minPrice = materialPrice;
          }
        }
      });

      return minPrice;
    }
  }
}

export default OldQuotePricing;
export { OldQuotePricing };